import type React from 'react';

import type { EventId } from '@vlabs/api/artemy/model/EventId';
import { artemyEventApi, EventApiProvider } from '@vlabs/monokit/entities/events/api';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import {
  AllMatchesPoint3,
  EventDetailsInfo,
  EventDetectionPoint3,
  EventMediaViewer,
  TopMatchCardPoint3,
} from '@vlabs/monokit/widgets';
import { useHasPermission, usePageAccess } from '@vlabs/permissions';
import { useParams } from 'react-router-dom';

import st from './EventDetailsPage.module.sass';
import { EventDetailsPageHeader } from './header/EventDetailsPageHeader';
import { useEventDetailsPageTranslation } from './i18n';

function EventDetailsPage(): React.JSX.Element {
  const { t } = useEventDetailsPageTranslation();
  const { eventId } = useParams<{ eventId: EventId }>();

  const canReadHandler = useHasPermission('handler', 'read');
  const canViewHandlersPage = usePageAccess('handlers');
  const canReadStream = useHasPermission('stream', 'read');

  return (
    <EventApiProvider api={artemyEventApi}>
      <Page>
        <PageContent>
          <EventDetailsPageHeader />
          <div className={st.Root}>
            <div className={st.Info}>
              <EventDetailsInfo
                canReadHandler={canReadHandler}
                canViewHandlersPage={canViewHandlersPage}
                eventId={eventId}
              />
            </div>
            <div className={st.MatchesContainer}>
              <EventMediaViewer
                canViewVideoArchive={canReadStream}
                eventId={eventId}
              />

              <div className={st.Section}>
                <h5>{t('title', { context: 'detection' })}</h5>
                <EventDetectionPoint3
                  className={st.EventDetection}
                  eventId={eventId}
                />
              </div>

              <TopMatchCardPoint3 eventId={eventId} />
              <AllMatchesPoint3 eventId={eventId} />
            </div>
          </div>
        </PageContent>
      </Page>
    </EventApiProvider>
  );
}

export { EventDetailsPage };
